import { render, staticRenderFns } from "./EditPathway.vue?vue&type=template&id=4c9c554a&lang=pug&"
import script from "./EditPathway.vue?vue&type=script&lang=js&"
export * from "./EditPathway.vue?vue&type=script&lang=js&"
import style0 from "./EditPathway.vue?vue&type=style&index=0&id=4c9c554a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports